import { useState } from 'react';
import { SideBarItem } from 'components/sidebar';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';
import PermissionHandler from 'components/permission-handler';
import { List, Collapse, ListItem, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';

type CollapseMenuProps = {
  sideBarItem: SideBarItem;
};

const CollapseMenu = ({ sideBarItem }: CollapseMenuProps) => {
  // other hooks
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // useState hooks
  const [open, setOpen] = useState(false);

  // dynamic variables
  const isSelectedSubMenuless = !!sideBarItem.route && pathname === `/${sideBarItem.route}`;
  const isSelectedWithSubMenu =
    sideBarItem.subMenu &&
    sideBarItem.subMenu.map((subMenuItem) => subMenuItem.route).some((route) => pathname === `/${route}`);

  // sync helper functions
  const handleClick = () => {
    setOpen(!open);
  };

  return !sideBarItem.subMenu ? (
    <PermissionHandler requiredPermissionCodes={sideBarItem.permissions}>
      <ListItem disablePadding sx={{ display: 'block' }} onClick={() => navigate(`/${sideBarItem.route}`)}>
        <ListItemButton selected={isSelectedSubMenuless}>
          <ListItemIcon>{sideBarItem.icon}</ListItemIcon>

          <ListItemText primary={sideBarItem.name} />
        </ListItemButton>
      </ListItem>
    </PermissionHandler>
  ) : (
    <PermissionHandler requiredPermissionCodes={sideBarItem.permissions}>
      <ListItem disablePadding sx={{ display: 'block' }}>
        <ListItemButton onClick={handleClick} selected={!open && isSelectedWithSubMenu}>
          <ListItemIcon>{sideBarItem.icon}</ListItemIcon>

          <ListItemText primary={sideBarItem.name} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {sideBarItem.subMenu.map((subMenuItem, index) => (
              <PermissionHandler requiredPermissionCodes={subMenuItem.permissions} key={index}>
                <ListItem disablePadding sx={{ display: 'block' }} onClick={() => navigate(`/${subMenuItem.route}`)}>
                  <ListItemButton selected={pathname === `/${subMenuItem.route}` || false}>
                    <ListItemIcon>{subMenuItem.icon}</ListItemIcon>
                    <ListItemText primary={subMenuItem.name} />
                  </ListItemButton>
                </ListItem>
              </PermissionHandler>
            ))}
          </List>
        </Collapse>
      </ListItem>
    </PermissionHandler>
  );
};

export default CollapseMenu;
